// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6178a3df","566":"51e6d2aa"}[chunkId] + ".chunk.js";
};